import React from "react"

class FolioItemsDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.row.folio_items && this.props.row.folio_items.length > 0) {
      var folio_items = this.props.row.folio_items.map(function(folio_item) {
        return <li key={folio_item.id}>{folio_item.id}</li>
      })
      return (
        <ul style={{marginBottom: 0}}>{folio_items}</ul>
      );
    } else {
      return(
        <span className="none">{I18n.t('none')}</span>
      )
    }
  }
};

export default FolioItemsDataType